import { type ConceptGroup } from '../types/concept-group.types';

export const mockConceptGroups: ConceptGroup[] = [
  {
    omopConceptGroupId: '11932426203163132-Verantos',
    conceptGroupName: 'Specific IgE - Outdoor - Tree / Plant / Weed / Grass / Flower',
    domains: 'Procedure, Measurement, Observation',
    conceptCount: 270,
    owner: 'Verantos',
    modifiedOn: undefined,
  },
  {
    omopConceptGroupId: '5635606892253958637-Verantos',
    conceptGroupName: 'ICS - fluticasone propionate',
    domains: 'Drug',
    conceptCount: 218,
    owner: 'Verantos',
    modifiedOn: new Date('2025-01-01'),
  },
  {
    omopConceptGroupId: '5380765699744777914-Verantos',
    conceptGroupName: 'Pre-bronchodilator FVC',
    domains: 'Measurement, Observation',
    conceptCount: 5,
    owner: 'Verantos',
    modifiedOn: new Date('2025-01-01'),
  },
  {
    omopConceptGroupId: '1321262459456621312-Verantos',
    conceptGroupName: 'Pre-bronchodilator FEV1',
    domains: 'Measurement',
    conceptCount: 1,
    owner: 'Verantos',
    modifiedOn: new Date('2025-01-01'),
  },
  {
    omopConceptGroupId: '2132024031996420206-Verantos',
    conceptGroupName: 'FEV1/FVC',
    domains: 'Measurement, Observation',
    conceptCount: 3,
    owner: 'Verantos',
    modifiedOn: new Date('2025-01-01'),
  },
  {
    omopConceptGroupId: '1446748021559429916-Verantos',
    conceptGroupName: 'Specific IgE - Primary allergen - Dog',
    domains: 'Measurement',
    conceptCount: 12,
    owner: 'Verantos',
    modifiedOn: new Date('2025-01-01'),
  },
  {
    omopConceptGroupId: '2265157949631466066-Verantos',
    conceptGroupName: 'FVC (predicted)',
    domains: 'Measurement',
    conceptCount: 1,
    owner: 'Verantos',
    modifiedOn: new Date('2025-01-01'),
  },
  {
    omopConceptGroupId: '4427360766023136359-Verantos',
    conceptGroupName: 'morphine',
    domains: 'Drug, Observation',
    conceptCount: 11843,
    owner: 'Verantos',
    modifiedOn: new Date('2025-01-01'),
  },
  {
    omopConceptGroupId: '4686710729822831568-Verantos',
    conceptGroupName: 'Angioneurotic edema codes for chronic spontaneous urticaria (CSU) algorithm',
    domains: 'Observation, Condition',
    conceptCount: 21,
    owner: 'Verantos',
    modifiedOn: new Date('2025-01-01'),
  },
  {
    omopConceptGroupId: '204025913236131978-Verantos',
    conceptGroupName: 'Thrombolysis procedures for stroke',
    domains: 'Procedure',
    conceptCount: 3,
    owner: 'Verantos',
    modifiedOn: new Date('2025-01-01'),
  },
];
